<template>
  <div :class="$style.container" v-if="dataCollectionActivityLogs">
    <div :class="$style.titleSection">
      <div :class="$style.title">DATA HISTORY</div>
      <button @click="handleNavigate" class="button" :class="$style.button">
        <span>Go to Data History</span>
        <span class="icon">
          <i class="fas fa-chevron-right"></i>
        </span>
      </button>
    </div>

    <div :class="$style.contentSection">
      <template v-if="histories.length > 0">
        <p-list-item
          v-for="(history, index) in histories"
          :key="`activity${index}`"
          :title="`${history.datetime}`"
        >
          <p>
            <b>{{ history.email }}</b>
            {{ history.description }}
          </p>
        </p-list-item>
      </template>
      <div :class="$style.noDataState" v-else>No data history found</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { AuditDetail } from '@/store/modules/audits/types/audits.types';
import { DataCollectionActivityLogRequestPayload } from '../../../store/modules/audits/types/audits.types';
import dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import { DATE_FORMAT } from '@/utils/date.util';
import { useUserEmail } from '@/utils/user.util';

// @ts-ignore
dayjs.extend(relativeTime);

@Component({
  components: {},
})
export default class AuditDataHistoryList extends Vue {
  @Prop() public auditDetail!: AuditDetail;

  @Action('audits/getDataCollectionActivityLogs')
  public getDataCollectionActivityLogs!: (
    payload: DataCollectionActivityLogRequestPayload,
  ) => void;

  @State((state) => state.audits.dataCollectionActivityLogs)
  public dataCollectionActivityLogs!: any;

  get auditId() {
    return this.$route.params.auditId;
  }

  public handleNavigate() {
    this.$emit('changeActiveTab', '#dataHistory');
  }

  public async mounted() {
    await this.getDataCollectionActivityLogs({
      auditId: +this.auditId,
      fromDate: new Date(this.auditDetail.startDate),
      toDate: new Date(),
    });
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  get histories() {
    const userEmail = this.userEmail;
    if (Array.isArray(this.dataCollectionActivityLogs)) {
      return this.dataCollectionActivityLogs.slice(0, 5).map((log) => {
        const today = dayjs().format(DATE_FORMAT);
        const yesterday = dayjs().add(-1, 'day').format(DATE_FORMAT);
        let total: number = 0;
        log.dataCollectionRecords.forEach((record: any) => {
          total += Number(record.total);
        });
        const dataUpdatedAt = dayjs(new Date(log.recordedStartDateTime)).format(
          DATE_FORMAT,
        );
        let dateToDisplay;
        if (dataUpdatedAt === today) {
          dateToDisplay = 'Today';
        } else if (dataUpdatedAt === yesterday) {
          dateToDisplay = 'Yesterday';
        } else {
          dateToDisplay = dataUpdatedAt;
        }
        return {
          datetime: dateToDisplay,
          email: log.user.email === userEmail ? 'You' : log.user.email,
          description: `added ${total} responses`,
        };
      });
    }
    return [];
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px 0;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }

  .contentSection {
    box-shadow: 0 1px 2px $grey-border, 0 1px 2px $grey-border;
    border: 0.5px solid $grey-border;
    overflow: hidden;
    border-radius: 6px;
    background: white;
  }

  .noDataState {
    padding: 1rem;
    font-size: 18px;
    font-weight: bold;
    color: #9f9f9f;
    text-align: center;
    height: 155px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
